import { styled } from 'styled-components'

import { outline } from 'core/styles'

/** Use this in between instances of CardSection as desired */
const Divider = styled.div<{
  marginLeft?: string
  full?: boolean
}>`
  grid-column: 1 / -1;
  margin-left: ${(p) => (p.full ? '0' : (p.marginLeft ?? '24px'))};
  border-bottom: 1px solid ${outline};
`
export default Divider
